"use client";

import { useEffect, useRef } from "react";
import Search from "@/assets/icons/Search";
import classes from "./SearchMoreContainer.module.scss";
import Hamburger from "@/assets/icons/Hamburger";
import { useState } from "react";
import SearchPopup from "../SearchPopup/SearchPopup";
import MorePopup from "../MorePopup/MorePopup";
import { useTheme } from "@/components/ThemeProvider/ThemeProvider";
import CrossIcon from "@/assets/icons/CrossIcon";
import RadioButton from "@/components/RadioButton/RadioButton";

const SearchMoreContainer = () => {
  const [searchVisibility, setSearchVisbility] = useState(false);
  const [moreVisibility, setMoreVisbility] = useState(false);

  const containerRef = useRef<HTMLDivElement | null>(null);

  const { theme } = useTheme();

  const iconColor = theme === "light" ? "#FFFFFF" : "#CCCCCC";

  const searchClickContainer = () => {
    setMoreVisbility(false);
    setSearchVisbility((prevState) => !prevState);
  };

  const moreClickContainer = () => {
    setSearchVisbility(false);
    setMoreVisbility((prevState) => !prevState);
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setSearchVisbility(false);
        setMoreVisbility(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={classes["search-more-container"]} ref={containerRef}>
      <div
        className={classes["search-btn-container"]}
        onClick={searchClickContainer}
      >
        Search
        {searchVisibility ? (
          <div className={classes["more-icon-container"]}>
            <Search color={iconColor} />
          </div>
        ) : (
          <div className={classes["more-icon-container"]}>
            <Search color={iconColor} />
          </div>
        )}
      </div>

      <div className={classes["radio-more-container"]}>
        <RadioButton className={classes["radio-button"]} />

        <div
          className={classes["more-btn-container"]}
          onClick={moreClickContainer}
        >
          <>More </>

          {moreVisibility ? (
            <div className={classes["more-icon-container"]}>
              <CrossIcon color={iconColor} />
            </div>
          ) : (
            <div className={classes["more-icon-container"]}>
              <Hamburger color={iconColor} />
            </div>
          )}
        </div>
      </div>

      {searchVisibility && (
        <div className={classes["search-pop-up-wrapper"]}>
          <SearchPopup setSearchVisbility={setSearchVisbility} />
        </div>
      )}

      {moreVisibility && (
        <div className={classes["search-pop-up-wrapper"]}>
          <MorePopup setMoreVisbility={setMoreVisbility} />
        </div>
      )}
    </div>
  );
};

export default SearchMoreContainer;
